var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "68.904 50.211 114.767 111.289",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.376 67.5996C112.376 61.8395 117.049 57.1663 122.809 57.1663H129.765C135.525 57.1663 140.198 61.8395 140.198 67.5996V144.111C140.198 149.871 135.525 154.544 129.765 154.544H122.809C117.049 154.544 112.376 149.871 112.376 144.111V67.5996ZM70.6426 109.333C70.6426 103.573 75.3159 98.8997 81.0759 98.8997H88.0315C93.7916 98.8997 98.4649 103.573 98.4649 109.333V144.111C98.4649 149.871 93.7916 154.544 88.0315 154.544H81.0759C75.3159 154.544 70.6426 149.871 70.6426 144.111V109.333ZM164.543 71.0774H171.498C177.259 71.0774 181.932 75.7507 181.932 81.5108V144.111C181.932 149.871 177.259 154.544 171.498 154.544H164.543C158.783 154.544 154.109 149.871 154.109 144.111V81.5108C154.109 75.7507 158.783 71.0774 164.543 71.0774Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsActive);
export default __webpack_public_path__ + "static/media/reports-active.4f27686b77dfb0c40d0dc8f10ce6dc34.svg";
export { ForwardRef as ReactComponent };